import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import SignupPage from "./pages/Registration/Signup";
import Password from "./pages/Registration/password";
import VerificationPage from "./pages/Registration/verification";
import GoogleRoute from "./pages/Registration/googleRoute";
import ResetPassword from "./pages/Passwords/resetPassword";
import ChangePassword from "./pages/Passwords/changePassword";
import { ChatProvider } from "./context/ChatContext";
import { SchoolSignupProvider } from "./context/SchoolSignupContext";
import Homescsbc from "./pages/Home/Homescsbc";
import ContentInner2 from "./pages/Home/ContentInner2";

import School from "./pages/Registration/School";
import LandingPage from "./pages/Registration/LandingPage";

import CreateSignup from "./pages/Registration/CreateSignup";
import SignupAccount from "./pages/Registration/SignupAccount";
import ForgetPassword from "./pages/Registration/ForgetPassword";
import Login from "./pages/Registration/Login";
import LoginPassword from "./pages/Registration/LoginPassword";
import ResetPass from "./pages/Registration/ResetPass";
import NewPassword from "./pages/Registration/NewPassword";
import AfterChatbot from "./pages/chats/AfterChatbot";
import GoogleDriveCallback from "./pages/chats/GoogleDriveCallback";
import Reply from "./pages/chats/Reply";
import { Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import OuterPage from "./pages/Home/OuterPage";
import HomePageTFT from "./pages/Home/HomePageTFT";
import SettingsProfile from "./pages/Settings/SettingsProfile";
import GoogleOAuthRedirectHandler from "./components/GoogleOAuthRedirectHandler";
import SubscriptionGate from "./components/SubscriptionGate";
import { confirmServerSession, isAccessTokenActive, isPublicAuthPath, redirectToLoginIfNeeded } from "./utils/sessionTimeout";
import { logoutUser } from "./utils/schoolSubscription";
// import { type } from "os";

const App = () => {



  const school_type = localStorage.getItem("school_type");

  const ProtectedRoute = ({ children }) => {
    const token = localStorage.getItem("access_token");
    const isAuthenticated = isAccessTokenActive(token);
    if (token && !isAuthenticated) {
      logoutUser();
    }
    // useEffect(() => {
    if (!isAuthenticated && window.location.pathname.includes("/afterchatbot")) {
      const fullPath = window.location.pathname + (window.location.search || "");
      localStorage.setItem("before_school_path", fullPath);
    }

    // }, [isAuthenticated]);



    return isAuthenticated ? (
      <SubscriptionGate>{children}</SubscriptionGate>
    ) : (
      <Navigate to="/landingpage" replace />
    );
  };





  const ProtectedForSignup = ({ children }) => {
    const rawData = sessionStorage.getItem('signupDataSession');

    // Parse the session data
    const signupDataSession = rawData ? JSON.parse(rawData) : null;

    const isSignedUp = signupDataSession?.schoolName;

    return isSignedUp ? children : <Navigate to="/landingpage" replace />;
  };

  const SessionTimeout = () => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
      const enforceSession = () => {
        const token = localStorage.getItem("access_token");
        if (!token || isAccessTokenActive(token)) return;
        redirectToLoginIfNeeded();
        const path = location.pathname;
        if (!isPublicAuthPath(path)) {
          navigate("/landingpage", { replace: true });
        }
      };

      enforceSession();
      confirmServerSession();
      const timer = setInterval(() => {
        enforceSession();
        confirmServerSession();
      }, 60 * 1000);
      const onPointerDown = () => {
        confirmServerSession();
      };
      document.addEventListener("pointerdown", onPointerDown, true);
      return () => {
        clearInterval(timer);
        document.removeEventListener("pointerdown", onPointerDown, true);
      };
    }, [navigate, location.pathname]);

    return null;
  };

  const ProtectedSchoolRoute = () => {
    const location = useLocation();
    const canAccessSchool = Boolean(location.state?.fromLanding);

    return canAccessSchool ? <School /> : <Navigate to="/landingpage" replace />;
  };


  return (
    <ChatProvider>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        closeOnClick
        pauseOnHover
        draggable
        theme="light"
      />


      <SchoolSignupProvider>
        <Router>
          <SessionTimeout />
          <GoogleOAuthRedirectHandler>
          <Routes>
            {console.log(school_type, "school_type")}
            {school_type === "tft" ?
              (
                <Route path="/" element={<ProtectedRoute>
                  {/* <AfterChatbot /> */}
                  <HomePageTFT />
                </ProtectedRoute>} />
              ) :
              (
                <Route path="/" element={<ProtectedRoute> <Homescsbc /> </ProtectedRoute>} />
              )
            }


            <Route path="*" element={
              <ProtectedRoute>
                {/* <HomePage /> */}
                <Homescsbc />
              </ProtectedRoute>
              // <HomePage />
            }
            />


            {/* <Route path="/homepage" element={
             <ProtectedRoute>
          <AfterLogin />
          </ProtectedRoute>
          } /> */}
            <Route path="/landingpage" element={<LandingPage />} />
            <Route path="/google" element={<GoogleRoute />} />
            <Route path="/authorize" element={<SignupPage />} />
            <Route path="/signup/password" element={<Password />} />
            <Route path="/login/password" element={<Password />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/change-password/new" element={<ChangePassword />} />
            <Route path="/password" element={<Password />} />
            {/* <Route path="/profile" element={<AboutYou/>} /> */}
            <Route path="/verification" element={<VerificationPage />} />
            {/* <Route path="/homee" element={<Homee/>} /> */}

            <Route path="/school" element={<ProtectedSchoolRoute />} />

            <Route path="/createsignup" element={
              <ProtectedForSignup><CreateSignup /></ProtectedForSignup>
            } />
            <Route path="/signupaccount" element={<ProtectedForSignup><SignupAccount /></ProtectedForSignup>} />
            <Route path="/signUpOtp" element={<ProtectedForSignup><ForgetPassword /></ProtectedForSignup>} />
            <Route path="/forgetpassword" element={<ForgetPassword />} />
            <Route path="/login-page" element={<ProtectedForSignup><Login /></ProtectedForSignup>} />
            <Route path="/login-password" element={<ProtectedForSignup><LoginPassword /></ProtectedForSignup>} />
            <Route path="/reset-pass" element={<ProtectedForSignup><ResetPass /></ProtectedForSignup>} />
            <Route path="/change-new-password" element={<NewPassword />} />
            {/* <Route path="/homescsbc" element={<Homescsbc/>} /> */}
            <Route path="/afterchatbot" element={<ProtectedRoute><AfterChatbot /></ProtectedRoute>} />
            <Route path="/google-drive-callback" element={<ProtectedRoute><GoogleDriveCallback /></ProtectedRoute>} />
            <Route path="/ContentInner2" element={<ProtectedRoute><ContentInner2 /></ProtectedRoute>} />
            <Route path="/reply" element={<ProtectedRoute><Reply /></ProtectedRoute>} />
            <Route path="/outer-page" element={<ProtectedRoute><OuterPage /></ProtectedRoute>} />
            <Route path="/settings" element={<ProtectedRoute><SettingsProfile /></ProtectedRoute>} />
            <Route path="/afterchatbot/:historySize/:id/:types/:schoolCodes" element={<ProtectedRoute><AfterChatbot /></ProtectedRoute>} />


          </Routes>
          </GoogleOAuthRedirectHandler>
        </Router>
      </SchoolSignupProvider>
    </ChatProvider>
  );
};

export default App;
